import { createSlice } from '@reduxjs/toolkit';

const patientSlice = createSlice({
    name : 'staff',
    initialState : {
        patients : null,
        pagination: null,
    },
    reducers : {
        setSystemPatients: (state , action) => {
            state.patients = action.payload.patients;
            state.pagination = action.payload.pagination;
        },
    }
})


export const { setSystemPatients } = patientSlice.actions;

export default patientSlice.reducer;